import React, { Fragment, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Tab } from '@material-ui/core';

import {
  SectionCard,
  DetailsList,
  Chip,
  LoadingSpinner,
  ErrorComponent,
  JsonDisplay
} from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { GQLJob } from '@jewelutions/core-crm-server-api-client-domain';
import { TabPanel, TabList, TabContext } from '@material-ui/lab';
import { CommonLogic } from '@jewelutions/core-common-logic';

const JobDetails: React.FC = () => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const jobId = PlatformNavigation.jobDetails.paramsFromPath(useRouteMatch()).jobId;
  const history = useHistory();
  const { t: translate } = useTranslation();
  const [tabValue, setTabValue] = useState('OUTPUT');

  const { data, loading, error, refetch } = GQLOperationBuilder.job.getJob({
    jobId: jobId
  });

  const handleTabChange = (event: any, newValue: string) => {
    setTabValue(newValue);
  };

  if (loading) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={refetch}
        message={error.message}
      />
    );

  const job: GQLJob = GQLOperationBuilder.job.jobFromResponse(data);

  return (
    <Fragment>
      <Grid item style={{ marginTop: '8px' }}>
        <SectionCard title="Overview" fitContent>
          <DetailsList
            list={[
              {
                primary: 'Job state',
                secondary: job.state
              },
              {
                primary: 'Job ID',
                secondary: job.id
              },
              {
                primary: 'Type',
                secondary: job.type
              },
              {
                primary: 'Created At',
                secondary: new Date(Date.parse(job.createdAt)).toLocaleString()
              },
              {
                primary: 'Started At',
                secondary: job.startedAt
                  ? new Date(Date.parse(job.startedAt)).toLocaleString()
                  : 'NOT STARTED'
              },
              {
                primary: 'Finished At',
                secondary: job.finishedAt
                  ? new Date(Date.parse(job.finishedAt)).toLocaleString()
                  : 'NOT FINISHED'
              }
            ]}
          />
        </SectionCard>
        <SectionCard title="Job configuration & execution details">
          <TabContext value={tabValue}>
            <TabList
              onChange={(event, tabIndex) => handleTabChange(event, tabIndex)}
              aria-label="currency-tabs"
            >
              <Tab label={'INPUT'} value={'INPUT'} />
              <Tab label={'OUTPUT'} value={'OUTPUT'} />
            </TabList>
            <TabPanel value="INPUT">
              <JsonDisplay object={JSON.parse(CommonLogic.Base64.fromBase64(job.input))} />
            </TabPanel>
            <TabPanel value="OUTPUT">
              {job.output && <JsonDisplay object={JSON.parse(CommonLogic.Base64.fromBase64(job.output))} />}
            </TabPanel>
          </TabContext>
        </SectionCard>
      </Grid>
    </Fragment>
  );
};

export default JobDetails;
